/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChessBishop = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2a3 3 0 0 1 2.867 3.883A4.389 4.389 0 0 1 16 8.848c0 .398-.052.784-.15 1.152H18v2h-2.4c.67 1.898 1.782 3.3 2.707 4.016A3 3 0 0 1 21 19v3H3v-3a3 3 0 0 1 2.818-2.994c.897-.716 1.963-2.112 2.606-4.006H6v-2h2.15A4.51 4.51 0 0 1 8 8.848c0-1.14.424-2.191 1.132-2.965A3 3 0 0 1 12 2zM6 18a1 1 0 0 0-1 1v1h14v-1a1 1 0 0 0-1-1zm4.516-6c-.445 1.578-1.155 2.939-1.954 4h6.955a12.092 12.092 0 0 1-2.016-4zm3.101-4.477a2.982 2.982 0 0 1-3.235 0A2.43 2.43 0 0 0 10 8.848c0 .426.106.818.283 1.152h3.434c.177-.334.283-.726.283-1.152 0-.504-.145-.958-.383-1.325zM12 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChessBishop as ChessBishop };
